import { InjectionToken } from '@angular/core';
import { MojoAttachmentService } from 'mojo-irp-attachments';

export const ATTACHMENT_SERVICE = new InjectionToken<MojoAttachmentService>(
  'MojoAttachmentService',
);
